<template>
  <v-dialog :value="showModal" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Estornar Pagamento {{ transaction_id }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex sm6>
              <v-text-field
                label="Usuário"
                v-model="user_name"
                disabled
                required
              ></v-text-field>
            </v-flex>
            <v-flex sm6>
              <v-text-field
                label="Pagamento"
                v-model="payment"
                disabled
                required
              ></v-text-field>
            </v-flex>

            <v-flex sm6>
              <v-text-field
                label="Status"
                v-model="status"
                disabled
                required
              ></v-text-field>
            </v-flex>

            <v-flex sm6>
              <v-text-field
                label="Pré Autorização"
                v-model="paymentValue"
                disabled
                required
              ></v-text-field>
            </v-flex>

            <v-flex sm6>
              <v-text-field
                label="Captura"
                v-model="totalValueCharged"
                disabled
                required
              ></v-text-field>
            </v-flex>

            <v-flex sm6>
              <v-text-field
                label="Motivo"
                v-model="observation"
                :disabled="validateObservationField()"
                required
                :error-messages="observationErrors"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex sm6>
              <v-select
                label="Tipo do estorno"
                :items="typesChargeback"
                v-model="type"
                :rules="[v => !!v || 'Este campo é obrigatório.']"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-flex sm12 v-if="status == 'paid'">
            <label for="model">Valor do estorno:</label>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span
                  class="input-group-text font-weight-medium"
                  id="basic-addon1"
                >
                  R$
                </span>
              </div>
              <money
                v-bind="money"
                v-model="chargebackValue"
                class="form-control"
              >
              </money>
            </div>
          </v-flex>

          <v-flex sm12 v-if="status == 'paid'">
            <v-text-field
              label="Senha"
              required
              v-model="password"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
              :error-messages="passwordErrors"
            ></v-text-field>
          </v-flex>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="$emit('close')"
          >Cancelar</v-btn
        >
        <v-btn
          color="blue darken-1"
          text
          @click.prevent="$v.$invalid ? $v.$touch() : refund()"
          >Estornar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import VehicleRequestController from '../../controllers/VehicleRequestController';
import NumberHelper from './../../helpers/NumberHelper';
export default {
  data() {
    return {
      vehicleRequestController: new VehicleRequestController(this.$resource),
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: true,
      },
      typesChargeback: [
        'Reembolso Abascimento',
        'Saque Carteira',
        'Cancelamento Reserva',
        'Multa de Atraso',
        'Outros',
      ],
      payment: '',
      status: '',
      observation: '',
      type: '',
      paymentValue: 0,
      chargebackValue: 0,
      totalValueCharged: null,
      user_name: null,
      transaction_id: null,
      client_id: localStorage.getItem('client_id'),
      show1: false,
      password: null,
    };
  },
  mixins: [validationMixin],
  validations() {
    if (this.status === 'paid') {
      return { password: { required }, observation: { required } };
    }
    return { observation: { required } };
  },
  computed: {
    observationErrors() {
      const errors = [];
      if (!this.$v.observation.$dirty) return errors;
      !this.$v.observation.required && errors.push('Campo obrigatório.');
      return errors;
    },
    typeErrors() {
      const errors = [];
      if (!this.$v.type.$dirty) return errors;
      !this.$v.type.required && errors.push('Campo obrigatório.');
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push('Campo obrigatório.');
      return errors;
    },
  },
  props: {
    showModal: Boolean,
    transaction: Object,
  },
  methods: {
    async refund() {
      try {
        console.log(this.type);
        if (this.observation == '' || this.type == '') {
          return this.$awn.alert('Campo de motivo é obrigatório!');
        }
        let chargebackValueInCents = this.realToCents(this.chargebackValue);
        let response = await this.vehicleRequestController.refundPayment(
          this.transaction_id,
          this.observation,
          this.client_id,
          chargebackValueInCents,
          this.status,
          this.password,
          this.type
        );
        this.$awn.success(response.body.message);
      } catch (e) {
        this.$awn.alert(e.message ? e.message : e.body);
      } finally {
        this.cleanForm();
        this.$emit('refundFinish');
      }
    },
    realToCents(value) {
      value = value + '';
      value = value.replace(',', '');
      while (value.includes('.')) {
        value = value.replace('.', '');
      }
      while (value[0] == '0') {
        value = value.substring(1);
      }
      return Number.parseInt(value);
    },
    cleanForm() {
      this.payment = '';
      this.status = '';
      this.observation = '';
      this.paymentValue = 0;
      this.chargebackValue = 0;
      this.password = null;
    },
    validateObservationField() {
      return this.status === 'refund';
    },
    setValues(item) {
      let value = item.valor_pre_autorizado;
      let valueCharged = item.total_value_charged
        ? item.total_value_charged
        : 0;
      this.transaction_id = item.transaction_id ? item.transaction_id : item.id;
      this.payment = item.type;
      this.user_name = item.user_name;

      if (this.payment === 'pre_authorized') {
        this.payment = 'Pré autorizado';
      } else if (this.payment === 'reservation') {
        this.payment = 'Reserva';
      } else if (this.payment === 'surplus_check_out') {
        this.payment = 'Valor excedente';
      }

      this.status = item.status;

      this.paymentValue = `R$ ${NumberHelper.formatPrice(value)}`;
      this.totalValueCharged = `R$ ${NumberHelper.formatPrice(valueCharged)}`;

      this.observation = item.payment_observation
        ? item.payment_observation
        : '';
      this.chargebackValue = this.paymentValue;
    },
  },
  watch: {
    transaction: function(item) {
      this.setValues(item);
    },
  },
};
</script>
